import React from "react";
import { useGetTransactions } from "../operations/queries/transactions";
import Alert from "./alert";
import CircularProgress from "./circular-progress";
import Transactions from "./transactions";

interface FilterPlateTransactionsProps {
  plateId: string;
}

const FilterPlateTransactions: React.FC<FilterPlateTransactionsProps> = ({
  plateId,
}) => {
  // Load all transactions that affected the current plate
  const { loading, error, transactions } = useGetTransactions({
    plate: {
      id: {
        equals: plateId,
      },
    },
  });

  return (
    <div className="space-y-5">
      {/* Error alert */}
      {!!error && (
        <Alert severity="error">
          <p>{error.message}</p>
        </Alert>
      )}

      {/* Transactions */}
      {loading ? (
        <CircularProgress />
      ) : !!transactions ? (
        <Transactions transactions={transactions} context="plate" />
      ) : null}
    </div>
  );
};

export default FilterPlateTransactions;
